export default {
  saveList: "api/subscriber-groups/",
  delList:(id) => `api/subscriber-groups/${id}/`,
  singleList:(id) => `api/subscriber-groups/${id}/`,
  putList:(id) => `api/subscriber-groups/${id}/`,
};
